import { render, staticRenderFns } from "./admin-exam-results.vue?vue&type=template&id=296ddc3c&scoped=true"
import script from "./admin-exam-results.vue?vue&type=script&lang=js"
export * from "./admin-exam-results.vue?vue&type=script&lang=js"
import style0 from "./admin-exam-results.vue?vue&type=style&index=0&id=296ddc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ddc3c",
  null
  
)

export default component.exports